module.exports = __webpack_public_path__ + "img/tema-1-13.0ecdd54f.png";